var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"auth-layout"}},[_c('auth-header'),_c('div',{staticClass:"router-view-area"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }